export const filterQuery = (requestBodyParam, entityName) => {
  let reqarray = [];
  Object.keys(requestBodyParam.is).forEach(key => {
    if (requestBodyParam.is[key] && requestBodyParam.is[key].length > 0) {
      requestBodyParam.is[key].forEach(item => {
        reqarray.push(getAttributeString(key) + ' is ' + item);
      });
    }
  });
  Object.keys(requestBodyParam.contains).forEach(key => {
    if (requestBodyParam.contains[key]) {
      let stringArr = requestBodyParam.contains[key].split('');

      if (stringArr.length > 1) {
        stringArr = requestBodyParam.contains[key].split(', ');
      }

      stringArr.forEach(item => {
        reqarray.push(getAttributeString(key) + ' contains ' + item);
      });
    }
  });
  Object.keys(requestBodyParam.startsWith).forEach(key => {
    if (requestBodyParam.startsWith[key]) {
      let stringArr = requestBodyParam.startsWith[key].split('');

      if (stringArr.length > 1) {
        stringArr = requestBodyParam.startsWith[key].split(', ');
      }

      stringArr.forEach(item => {
        reqarray.push(getAttributeString(key) + ' startsWith ' + item);
      });
    }
  });
  Object.keys(requestBodyParam.endsWith).forEach(key => {
    if (requestBodyParam.endsWith[key]) {
      let stringArr = requestBodyParam.endsWith[key].split('');

      if (stringArr.length > 1) {
        stringArr = requestBodyParam.endsWith[key].split(', ');
      }

      stringArr.forEach(item => {
        reqarray.push(getAttributeString(key) + ' endsWith ' + item);
      });
    }
  });

  if (requestBodyParam.since) {
    let stringArr = requestBodyParam.since.split('');

    if (stringArr.length > 1) {
      stringArr = requestBodyParam.since.split(', ');
    }

    stringArr.forEach(item => {
      reqarray.push('Created since ' + item);
    });
  }

  if (requestBodyParam.before) {
    let stringArr = requestBodyParam.before.split('');

    if (stringArr.length > 1) {
      stringArr = requestBodyParam.before.split(', ');
    }

    stringArr.forEach(item => {
      reqarray.push('Created before ' + item);
    });
  }

  if (requestBodyParam.on) {
    let stringArr = requestBodyParam.on.split('');

    if (stringArr.length > 1) {
      stringArr = requestBodyParam.on.split(', ');
    }

    stringArr.forEach(item => {
      reqarray.push('Created on ' + item);
    });
  }

  Object.keys(requestBodyParam.risk).forEach(key => {
    if (key === 'riskRange' && requestBodyParam.risk[key]) {
      let score = requestBodyParam.risk[key].split(',');
      reqarray.push(entityName + ' Risk Score is ' + score[0] + ' to ' + score[1]);
    } else if (key === 'riskType') {
      if (requestBodyParam.risk[key].length > 0) {
        requestBodyParam.risk[key].forEach(item => {
          reqarray.push(entityName + ' ' + getAttributeString(key) + ' is ' + item);
        });
      }
    }
  });
  return reqarray;
};

const getAttributeString = text => {
  let result = text.replace(/([A-Z])/g, ' $1');
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);

  if (finalResult === 'Application List') {
    return 'Application';
  } else if (finalResult === 'Environment Name List') {
    return 'Environment Name';
  } else if (finalResult === 'Environment Id List') {
    return 'Environment Id';
  } else if (finalResult === 'Group Name List') {
    return 'Group Name';
  } else if (finalResult === 'Permission Name List') {
    return 'Permission Name';
  } else if (finalResult === 'Resource Name List') {
    return 'Service Resource Name';
  } else if (finalResult === 'Resource Type List') {
    return 'Service Resource Type';
  } else if (finalResult === 'Role Name List') {
    return 'Role Name';
  } else if (finalResult === 'User Account Name List') {
    return 'User Account Name';
  } else if (finalResult === 'App Name') {
    return 'Application';
  } else if (finalResult === 'Resource Name') {
    return 'Service Resource Name';
  } else if (finalResult === 'Resource Type') {
    return 'Service Resource Type';
  } else if (finalResult === 'User Name') {
    return 'User Account Name';
  } else {
    return finalResult;
  }
};